import styled from "styled-components";
import { Colors } from 'styles/app-styles';

export const NavItem_s = styled.a`
  margin-bottom: 25px;
  display: ${props => props.visible ? "block" : "none"};
  ${props => props.active && `border-bottom: 4px solid ${Colors.cerulean};`}
  svg {
    height: 27px;
    width: 27px;
    .r-svg {
      fill: ${props => props.active ? `${Colors.white}` : `${Colors.chateauGrey}`};
    }
  }
`

export const Sidebar_s = styled.div`
  background-color: ${Colors.blackPearl};
  display: flex;
  height: 100%;
  padding-top: 12px;
  top: ${props => props.summaryBarOpen ? '130px': '80px'};
  position: fixed;
  width: 90px;
  z-index: 200;

  > div:last-child {
    display: flex;
    flex-direction: column;
    padding-left: ${props => props.assetManagement ? '15px' : '30px'};
    margin-top: 8px;
  }
`

export const AppModes_s = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 5px;
`

export const AppMode_s = styled.a`
  border-radius: 2px;
  background: ${props => props.active && `${Colors.cerulean}`};
  color: ${Colors.white};
  font-weight: 500;
  padding: 8px 2px;
  transform: rotate(180deg);
  writing-mode: vertical-lr;
  &:hover {
    background: ${Colors.cerulean};
  }
  &:last-child {
    margin-top: 20px;
  }
`
